import { render } from "./AdminPerson.vue?vue&type=template&id=7d127545"
import script from "./AdminPerson.vue?vue&type=script&lang=js"
export * from "./AdminPerson.vue?vue&type=script&lang=js"

import "./AdminPerson.vue?vue&type=style&index=0&id=7d127545&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__